import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../../components/Box';
import { Button } from '../../../../../../components/Buttons';
import { selectNewVehicle } from '../../../../selectors';
import { createVehicleWithProps } from '../../../../actions';
import { selectWorks } from '../../../../../Api/selectors';
import { REQUEST_VEHICLE_FROM_AUTOTELEX } from '../../../../constants';
import { Loader } from '../../../../../../components/Loader';
import { PURCHASING_DATA_CRUD, PURCHASING_PRICES_CRUD } from '../../../../../../components/Permission/constants';
import { Permission } from '../../../../../../components/Permission';
import { VehicleCreateField } from '../../Field';
import cn from 'classnames';
import ButtonComponent from '../../../../../../containers/App/Components/Button/Button';
import styles from './Step1BaseIndewal.module.css';

const Container = styled.div`
  width: 100%;
  .cols {
  }
  .col {
    padding-right: 48px;
    @media (max-width: 768px) {
      width: 100%;
      min-width: 250px;
    }
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateStep1DefaultComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get vehicle() {
    return this.props.vehicle;
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    this.props.onSave();
  }

  get purchasingDataProps() {
    return ['creditor_company', 'creditor'];
  }

  get purchasingPricesProps() {
    return ['import'];
  }

  render() {
    if (this.props.fetchingFromAutotelex) return <Loader onCard />;
    const keyFieldsArray = this.props.values.creditor_company
      ? [
          'creditor_company',
          'creditor',
          'helga_id',
          'regplate',
          'vin',
          'mileage',
          'new_from_factory',
          'import',

          'ex_rental',
          'transport',
          'date_expected',
        ]
      : ['creditor_company', 'creditor'];
    return (
      <Container className={styles.container}>
        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <Wrapper className={styles.wrapper}>
              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.vehicle')}</h2>
                {keyFieldsArray.map(type => {
                  let permission = null;
                  if (this.purchasingDataProps.includes(type)) permission = PURCHASING_DATA_CRUD;
                  if (this.purchasingPricesProps.includes(type)) permission = PURCHASING_PRICES_CRUD;
                  return (
                    <Permission permission={permission}>
                      <VehicleCreateField
                        key={type}
                        type={type}
                        fetchFromAutotelex={type === 'regplate' && this.props.fetchFromAutotelex}
                        edit={this.props.edit}
                        vehicle_id={this.props.vehicle_id}
                      />
                    </Permission>
                  );
                })}
                {!this.props.values.regplate && this.props.edit && (
                  <h2 className={styles.title}>{this.lbl('vehicle.order.sell_with_license_plate')}</h2>
                )}
                {!this.props.values.regplate &&
                  this.props.edit &&
                  ['sell_with_license_plate', 'sell_without_license_plate'].map(type => (
                    <VehicleCreateField key={type} type={type} edit={this.props.edit} vehicle_id={this.props.vehicle_id} />
                  ))}
                {this.props.edit && <h2>{this.lbl('vehicle.order.vehicle.order.fix_damages')}</h2>}
                {this.props.edit &&
                  ['fix_damages', 'dont_fix_damages'].map(type => (
                    <VehicleCreateField key={type} type={type} edit={this.props.edit} vehicle_id={this.props.vehicle_id} />
                  ))}
                {this.props.values?.fix_damages == '1' &&
                  ['fix_damages_details'].map(type => (
                    <VehicleCreateField key={type} type={type} edit={this.props.edit} vehicle_id={this.props.vehicle_id} />
                  ))}
              </div>

              <div className={styles.containerFlex}>
                {this.props.values.creditor_company && (
                  <>
                    <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.general')}</h2>
                    {['brand_name', 'model_name', 'model_info', 'date_first_allowance'].map(type => (
                      <VehicleCreateField key={type} type={type} vehicle_id={this.props.vehicle_id} />
                    ))}
                    <h2 className={styles.title}>{this.lbl('vehicle.create.columns.exterior')}</h2>
                    {['body_type', 'base_color', 'secondary_color'].map(type => (
                      <VehicleCreateField key={type} type={type} vehicle_id={this.props.vehicle_id} />
                    ))}
                  </>
                )}
              </div>

              <div className={styles.containerFlex}>
                {this.props.values.creditor_company && (
                  <>
                    <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.drive')}</h2>
                    {['transmission_type', 'fuel_type', 'power', 'power_axle', 'battery_capacity'].map(type => (
                      <VehicleCreateField key={type} type={type} vehicle_id={this.props.vehicle_id} />
                    ))}
                    <h2 className={styles.title}>{this.lbl('vehicle.create.columns.emission')}</h2>
                    {/* TODO: when autotelex api will be set correctly */}
                    {['wltpCo2Emission', 'nedcCo2Emission', 'euro_class'].map(type => (
                      <VehicleCreateField key={type} type={type} vehicle_id={this.props.vehicle_id} edit={this.props.edit} />
                    ))}
                    {/* {['nedcCo2Emission', 'wltpCo2Emission'].map(type => (
                      <VehicleCreateField key={type} type={type} />
                    ))} */}
                  </>
                )}
              </div>
            </Wrapper>
            <div className="d-flex justify-content-end mt-2">
              <ButtonComponent
                style="ButtonSoftEdit"
                disabled={!this.props.values.creditor_company}
                onClick={this.save.bind(this)}
              >
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

VehicleCreateStep1DefaultComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchingFromAutotelex: selectWorks([REQUEST_VEHICLE_FROM_AUTOTELEX]),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateStep1Default = compose(withConnect, withRouter)(VehicleCreateStep1DefaultComp);
